export interface ProfileHeroStat {
  label: string;
  value: string | number;
  onClick?: () => void;
}

interface Props {
  stats: ProfileHeroStat[];
}

export function ProfileHeroStats({ stats }: Props) {
  return (
    <div
      className="grid border-t border-white/10 text-center"
      style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}
    >
      {stats.map((stat) => (
        <button
          key={stat.label}
          type="button"
          onClick={stat.onClick}
          className={`bt-flat min-w-0 border-r border-white/10 px-0.5 py-3 last:border-r-0 ${
            stat.onClick ? '' : 'pointer-events-none cursor-default'
          }`}
        >
          <div className="truncate font-serif text-xl font-bold leading-none text-gold">{stat.value}</div>
          <div className="mt-1 truncate text-[10px] font-semibold uppercase tracking-wider text-white/55">
            {stat.label}
          </div>
        </button>
      ))}
    </div>
  );
}
